import type { IndicatorCardType } from '../../../../types/indicator-card';
import * as Unicons from '@iconscout/react-unicons';
import aulaImage from '../../../../assets/img/dashboard/aula.svg';
import flagImage from '../../../../assets/img/dashboard/flag.svg';
import { useUserKpiStore } from '../../../../store/home/user-kpi.store';
import { useTranslation } from 'react-i18next';

type FindOutWhatCardTypeIs = {
  [key in IndicatorCardType]: {
    title: string;
    value: string;
    image?: string;
    icon?: JSX.Element;
    color: string;
  };
};

interface UseIndicatorCardProps {
  cardType: IndicatorCardType;
}
export default function useIndicatorCard({ cardType }: UseIndicatorCardProps) {
  const { userKpi } = useUserKpiStore();
  const { t } = useTranslation(["instrutor"]);

  const classesAttend = (userKpi.quantidadeAulasAssistidas || 0).toString();
  const ongoingCourses = (userKpi.quantidadeCursosAndamento || 0).toString();
  const completedCourses = (
    userKpi.quantidadeCursosFinalizados || 0
  ).toString();
  const completedTrails = (userKpi.quantidadeTrilhasConcluidas || 0).toString();

  const findOutWhatCardTypeIs: FindOutWhatCardTypeIs = {
    aulasAssistidas: {
      title: t('instrutor:classesWatched'),
      value: classesAttend,
      image: aulaImage,
      color: 'var(--blue-theme)',
    },
    cursosEmAndamento: {
      title: t('instrutor:coursesInProgress'),
      value: ongoingCourses,
      icon: <Unicons.UilClock color="var(--white-color)" />,
      color: 'var(--blue-theme-light)',
    },
    cursosConcluidos: {
      title: t('instrutor:coursesCompleted'),
      value: completedCourses,
      icon: <Unicons.UilPostcard color="var(--white-color)" />,
      color: 'var(--blue-theme)',
    },
    trilhasConcluidas: {
      title: t('instrutor:trailsCompleted'),
      value: completedTrails,
      image: flagImage,
      color: 'var(--blue-theme-light)',
    },
  };

  const getCardType = findOutWhatCardTypeIs[cardType];

  return {
    getCardType,
  };
}
